export const GET_GHOST_ACCOUNT = "GET_GHOST_ACCOUNT";
export const CREATE_GHOST_ACCOUNT = "CREATE_GHOST_ACCOUNT";
export const UPDATE_GHOST_ACCOUNT_STATUS = "UPDATE_GHOST_ACCOUNT_STATUS";
export const DELETE_GHOST_ACCOUNT = "DELETE_GHOST_ACCOUNT";

export const OPEN_GHOST_ACCOUNT_DIALOG = "OPEN_GHOST_ACCOUNT_DIALOG";
export const CLOSE_GHOST_ACCOUNT_DIALOG = "CLOSE_GHOST_ACCOUNT_DIALOG";
